import React from 'react';
import CookieAnalytics from './cookie-analytics';
import PageAnalytics from './page-analytics';

const Analytics = () => (
  <>
    <PageAnalytics />
    <CookieAnalytics />
  </>
);

export default Analytics;
